export default __webpack_public_path__ + "static/media/imageC2.4602374c.png";